<template>
  <div
    class="el-main"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="AIがあなたに最適なテキストを生成しています"
  >
    <!--職種-->
    <div class="card" v-show="currentCardId == 'job-category'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>職種を入力</h2>
          <p>入力すると候補職種が表示されますので、選択してください</p>
        </div>

        <div class="card-content">
          <div class="item-name">あなたの職種</div>
          <div class="item-body">
            <div
              class="job-category-selector"
              style="width: 90%; position: relative"
            >
              <el-input
                v-model="jobSearchQuery"
                placeholder="あなたの職種を入力してください。"
                @input="onJobSearchInput"
                @focus="showJobDropdown = true"
                @blur="onJobSearchBlur"
                clearable
                class="input-lg"
              />
              <div
                v-show="showJobDropdown && filteredJobOptions.length > 0"
                class="job-dropdown-list"
              >
                <div
                  v-for="item in filteredJobOptions"
                  :key="item"
                  @mousedown.prevent="selectJobCategory(item)"
                  class="job-dropdown-item"
                >
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--学歴-->
    <div class="card" v-show="currentCardId == 'edu-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>学歴を入力</h2>
          <p>「自動入力」を使うと、入学・卒業年度を自動で計算できます</p>
          <el-checkbox v-model="formatData.notDisplayIjyo"
            >【以上】を表示しない</el-checkbox
          >
        </div>

        <div class="card-content">
          <div class="add-item">
            <div class="edu-history-action">
              <auto-educational-backgrounds
                v-on:create-educational-background="setEducationalBackgrounds"
                :year="basicData.birthYear"
                :month="basicData.birthMonth"
                :day="basicData.birthDay"
              ></auto-educational-backgrounds>
              <div class="button-reset">
                <el-button
                  v-if="
                    formatData.educationalHistories &&
                    formatData.educationalHistories.length > 1
                  "
                  @click="$modal.show('educational-reset')"
                  >リセット</el-button
                >
              </div>
              <modal
                name="educational-reset"
                :adaptive="true"
                :scrollable="true"
                height="auto"
              >
                <div class="v--modal-close-top">
                  <el-button
                    @click="$modal.hide('educational-reset')"
                    icon="el-icon-close"
                    type="text"
                  ></el-button>
                </div>
                <div class="title">学歴リセット</div>
                <span
                  >入力されている学歴をすべて削除します。よろしいですか？</span
                >

                <div class="text-left">
                  <el-button
                    type="primary"
                    @click="
                      $modal.hide('educational-reset')
                      resetEducationalBackgrounds()
                    "
                    >リセットする</el-button
                  >
                  <el-button @click="$modal.hide('educational-reset')"
                    >リセットしない</el-button
                  >
                </div>
              </modal>
            </div>
          </div>
          <div
            class="edit-form-item"
            v-if="
              formatId == 'rirekisho_job_new' ||
              formatId == 'rirekisho_job_new_single'
            "
          >
            <div class="item-name">卒業予定</div>
            <div class="item-body">
              <el-select
                v-model="formatData.gradeYear"
                placeholder="選択してください"
              >
                <el-option
                  v-for="item in gradeYearOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item
                v-on:add-history-item="addEducationalHistory"
                v-on:delete-history-item="deleteEducationalHistory"
                v-on:move-history-item="moveEducationalHistory"
                v-for="(item, index) in formatData.educationalHistories"
                @click.native="activateHistoryItem(item.uuid)"
                :item="item"
                :length="formatData.educationalHistories.length"
                :index="index"
                :key="item.uuid"
                :id="item.uuid"
                :class="{ active: activeHistoryItem == item.uuid }"
                :minYear="basicData.birthYear"
                :ref="'EducationalHistory_' + index"
                :createDate="formatData.createDate"
                :descriptionPlaceholder="'学歴を入力'"
                :descriptionMaxLength="descriptionMaxLength"
              ></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button
                icon="el-icon-plus"
                circle
                type="success"
                @click="addEducationalHistory()"
              ></el-button>
            </div>
          </div>
          <div
            class="attention-limit column"
            v-if="previewErrors.eduJobHistory"
          >
            <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
          </div>
        </div>
      </div>
    </div>

    <!--スキル-->
    <div class="card" v-show="currentCardId == 'skills'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>スキルを入力</h2>
          <p>スキルと熟練度を入力してください</p>
        </div>
        <div class="card-content">
          <transition-group name="fade" tag="div">
            <skill-item
              v-on:add-skill-item="addSkills"
              v-on:delete-skill-item="deleteSkills"
              v-on:move-skill-item="moveSkills"
              v-for="(item, index) in formatData.skills"
              @click.native="activateHistoryItem(item.uuid)"
              :item="item"
              :length="formatData.skills.length"
              :index="index"
              :key="item.uuid"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :ref="'Skills_' + index"
              :createDate="formatData.createDate"
              :descriptionPlaceholder="'スキル名を入力'"
              :descriptionMaxLength="descriptionMaxLength"
            ></skill-item>
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addSkills()"
            ></el-button>
          </div>
        </div>
      </div>
    </div>

    <!--免許・資格-->
    <div class="card" v-show="currentCardId == 'license-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>免許・資格を入力</h2>
          <p>主要な免許・資格は例文から選ぶことができます</p>
        </div>
        <div class="card-content">
          <div class="add-item">
            <el-button @click="$modal.show('license-dialog')" type="success"
              >例文から追加</el-button
            >
            <modal
              name="license-dialog"
              :adaptive="true"
              :scrollable="true"
              height="auto"
            >
              <div class="v--modal-close-top">
                <el-button
                  @click="$modal.hide('license-dialog')"
                  icon="el-icon-close"
                  type="text"
                ></el-button>
              </div>
              <div class="title">例文を選ぶ</div>
              <div class="description">
                <p>選択した例文が追加されます。</p>
              </div>
              <ul class="example-sentence">
                <li
                  v-for="(item, idx) in exampleSentences.license"
                  v-on:click="
                    addLicenseHistory(null, { description: item.description })
                    $modal.hide('license-dialog')
                  "
                  :key="idx"
                >
                  <div class="title">{{ item.title }}</div>
                  <div class="body" v-html="item.description"></div>
                </li>
              </ul>
              <div class="text-right">
                <el-button @click="$modal.hide('license-dialog')"
                  >閉じる</el-button
                >
              </div>
            </modal>
          </div>
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item
                v-on:add-history-item="addLicenseHistory"
                v-on:delete-history-item="deleteLicenseHistory"
                v-on:move-history-item="moveLicenseHistory"
                v-for="(item, index) in formatData.licenseHistories"
                @click.native="activateHistoryItem(item.uuid)"
                :item="item"
                :length="formatData.licenseHistories.length"
                :index="index"
                :key="item.uuid"
                :id="item.uuid"
                :class="{ active: activeHistoryItem == item.uuid }"
                :ref="'LicenseHistory_' + index"
                :minYear="basicData.birthYear"
                :createDate="formatData.createDate"
                :descriptionPlaceholder="'免許・資格を入力'"
                :descriptionMaxLength="descriptionMaxLength"
              ></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button
                icon="el-icon-plus"
                circle
                type="success"
                @click="addLicenseHistory()"
              ></el-button>
            </div>
            <div
              class="attention-limit column"
              v-if="previewErrors.licenseHistory"
            >
              <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--職歴-->
    <div class="card" v-show="currentCardId == 'job-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>職歴を入力</h2>
          <p>参加プロジェクトも記入することができます</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="add-item">
              <div class="button-reset">
                <el-button
                  type=""
                  v-if="
                    formatData.jobDetailHistories &&
                    formatData.jobDetailHistories.length > 1
                  "
                  @click="$modal.show('job-reset')"
                  >リセット</el-button
                >
              </div>
              <modal
                name="job-reset"
                :adaptive="true"
                :scrollable="true"
                height="auto"
              >
                <div class="v--modal-close-top">
                  <el-button
                    @click="$modal.hide('job-reset')"
                    icon="el-icon-close"
                    type="text"
                  ></el-button>
                </div>
                <div class="title">職歴リセット</div>
                <span
                  >入力されている職歴をすべて削除します。よろしいですか？</span
                >

                <div class="text-left">
                  <el-button
                    type="primary"
                    @click="
                      $modal.hide('job-reset')
                      resetJobHistories()
                    "
                    >リセットする</el-button
                  >
                  <el-button @click="$modal.hide('job-reset')"
                    >リセットしない</el-button
                  >
                </div>
              </modal>
            </div>
            <transition-group name="fade" tag="div">
              <jobdetail-item
                v-on:add-history-item="addJobHistory"
                v-on:delete-history-item="deleteJobHistory"
                v-on:move-history-item="moveJobHistory"
                v-on:add-project-history-item="addProjectHistory"
                v-on:delete-history-item-detail="deleteHistoryDetail"
                v-on:move-history-item-detail="moveJobHistoryDetail"
                v-for="(item, index) in formatData.jobDetailHistories"
                @click.native="activateHistoryItem(item.uuid)"
                :item="item"
                :length="formatData.jobDetailHistories.length"
                :index="index"
                :key="item.uuid"
                :id="item.uuid"
                :class="{ active: activeHistoryItem == item.uuid }"
                :ref="'JobHistory_' + index"
                :minYear="basicData.birthYear"
                :createDate="formatData.createDate"
                :activeHistoryItem="activeHistoryItem"
                :descriptionPlaceholder="'会社名を入力'"
                :descriptionMaxLength="descriptionMaxLength"
              >
              </jobdetail-item>
            </transition-group>
            <div class="add-list-item">
              <el-button
                icon="el-icon-plus"
                circle
                type="success"
                @click="addJobHistory()"
              ></el-button>
            </div>
            <div
              class="attention-limit column"
              v-if="previewErrors.eduJobHistory"
            >
              <i class="el-icon-warning"></i>&ensp;{{
                previewErrors.eduJobHistory
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--自己PR-->
    <div class="card" v-show="currentCardId == 'mypr'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>自己PRを入力</h2>
          <p>自己PRを入力してください。</p>
        </div>

        <div class="add-item">
          <el-button
            @click="$modal.show('ai-mypr-dialog')"
            id="prime-reasonai-btn"
            type="success"
            >最新のAIを使う</el-button
          >
        </div>

        <div class="card-content">
          <modal
            name="mypr-dialog"
            :adaptive="true"
            :scrollable="true"
            height="auto"
          >
            <div class="v--modal-close-top">
              <el-button
                @click="$modal.hide('mypr-dialog')"
                icon="el-icon-close"
                type="text"
              ></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">
                例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。
              </p>
            </div>
            <ul class="example-sentence">
              <li
                v-for="(item, idx) in exampleSentences.mypr"
                v-on:click="
                  formatData.mypr = item.description.replace(/<br>/gi, '\n')
                  $modal.hide('mypr-dialog')
                "
                :key="idx"
              >
                <div class="title">{{ item.title }}</div>
                <div class="body" v-html="item.description"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('mypr-dialog')">閉じる</el-button>
            </div>
          </modal>

          <!--AI自己PR-->
          <modal
            name="ai-mypr-dialog"
            :adaptive="true"
            :scrollable="true"
            height="auto"
            class="ai-mypr-modal"
          >
            <div class="v--modal-close-top">
              <el-button
                @click="$modal.hide('ai-mypr-dialog')"
                icon="el-icon-close"
                type="text"
              ></el-button>
            </div>

            <div class="mypr-title-block">
              <p class="mypr-title-catch">ヤギプライム限定</p>
              <h3>自分らしい文章にしよう</h3>
              <p class="mypr-lead">
                あなたにまつわる4つの質問で、より自分らしい文章を作成することができます。<br /><span
                  class="mypr-attention"
                  >※例文選択・AI再生成をすると、現在入力中の文章は上書きされますのでご注意ください。</span
                >
              </p>
            </div>

            <div v-if="!aiResultView">
              <ul class="example-sentence-list">
                <li class="example-sentence-item">
                  <p class="question-title">
                    質問1.あなたの長所と短所 <span>必須</span>
                  </p>
                  <p class="question-title">長所</p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="丁寧に取り組むことができるなど"
                      title="長所"
                      autocomplete="off"
                      v-model="formatData.ai_mypr_good"
                    ></el-input>
                  </div>
                  <p class="question-title">短所</p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="スケジュールがギリギリなど"
                      title="短所"
                      autocomplete="off"
                      v-model="formatData.ai_mypr_bad"
                    ></el-input>
                  </div>
                </li>
                <li class="example-sentence-item">
                  <p class="question-title">質問2.あなたの趣味</p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="ヤギを数えること"
                      title="あなたの趣味"
                      autocomplete="off"
                      v-model="formatData.ai_mypr_hobby"
                    ></el-input>
                  </div>
                </li>
                <li class="example-sentence-item">
                  <p class="question-title">質問3.今後やりたいこと</p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="ヤギを飼うこと"
                      title="今後やりたいこと"
                      autocomplete="off"
                      :autosize="{ minRows: 3, maxRows: 15 }"
                      v-model="formatData.ai_mypr_wanted"
                    ></el-input>
                  </div>
                </li>
                <li class="example-sentence-item">
                  <p class="question-title">質問4.その他アピールしたいこと</p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="ヤギに好かれること"
                      title="その他アピールしたいこと"
                      autocomplete="off"
                      :autosize="{ minRows: 3, maxRows: 15 }"
                      v-model="formatData.ai_mypr_appeal"
                    ></el-input>
                  </div>
                </li>
              </ul>
              <div class="text-right" style="margin-top: 10px">
                <p v-if="$globalVar.isYagiPrime" style="font-size: 0.8rem">
                  <span>1日利用回数：</span><span>5回</span>
                </p>
                <p v-else style="font-size: 0.8rem">
                  <span>利用回数：</span><span>1回</span>
                </p>
                <div class="prime-cv-block">
                  <el-button @click="getAIMypr()"
                    >この内容でAI自己PRを作成</el-button
                  >
                </div>
              </div>
            </div>
            <div v-else>
              <ul class="example-sentence">
                <li
                  v-on:click="
                    formatData.mypr = aiResultMyprResult.replace(/<br>/gi, '\n')
                    $modal.hide('ai-mypr-dialog')
                    aiResultView = false
                  "
                >
                  <div class="title">AIからの提案</div>
                  <div class="body" v-html="aiResultMyprResult"></div>
                </li>
              </ul>
              <div
                v-if="!$globalVar.isYagiPrime"
                class="text-right"
                style="margin-top: 10px"
              >
                ＼全文を表示する場合は／<br />
                <el-button
                  @click="goYagiprimeRegister"
                  id="prime-reasonai-register-btn"
                  v-if="$globalVar.in_app_payments"
                  style="
                    color: #fff;
                    background-color: #e3165c;
                    border-color: #e3165c;
                  "
                  >ヤギプライム会員になる</el-button
                >
              </div>
            </div>
            <div class="text-right">
              <el-button @click="$modal.hide('ai-mypr-dialog')"
                >閉じる</el-button
              >
            </div>
          </modal>
          <el-input
            type="textarea"
            v-model="formatData.mypr"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
          ></el-input>
          <div class="attention-limit character" v-if="previewErrors.mypr">
            <i class="el-icon-warning"></i>
            入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>
        </div>
      </div>
    </div>

    <!--趣味-->
    <div class="card" v-show="currentCardId == 'hobby'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>自分の趣味を選択する</h2>
          <p>記載したい趣味を選択してください</p>
        </div>
        <div class="card-content">
          <div class="edit-hobby-list">
            <figure
              v-for="(val, idx) in hobbyLabel"
              :class="checkedHobby(idx)"
              style="cursor: pointer"
              @click="selectHobby(idx, val)"
            >
              <img :src="hobbyImages[idx]" />
              <figcaption>{{ val }}</figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>

    <!--メイン画像-->
    <div class="card" v-show="currentCardId == 'main-image'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>自分をアピールする画像</h2>
          <p>画像をアップロードしてください、プレビューで確認できます</p>
        </div>
        <div class="card-content">
          <div
            class="edit-form-item flex justify-center align-items-stretch sp-direction-column"
          >
            <div class="rirekisho-photo-upload">
              <div
                class="rirekisho-photo-upload-image"
                v-if="formatData.mainImageSrc"
              >
                <img
                  :src="formatData.mainImageSrc"
                  style="width: 100%; height: auto; object-fit: contain"
                />
              </div>
              <div class="photo-upload-action" v-if="!formatData.mainImageSrc">
                <div v-if="!$globalVar.isYagiPrime" style="text-align: center">
                  <div
                    id="upload-photo-button"
                    @click="handleMainImageUploadClick"
                  >
                    🔓️ 写真をアップロードする
                  </div>
                  <p style="font-size: 0.8rem; margin-top: 5px; color: #666">
                    ヤギプライムに加入して、メイン画像を設定しよう
                  </p>
                </div>
                <upload-photo
                  v-else
                  v-on:upload-photo-complete="updateMainImage"
                ></upload-photo>
              </div>
              <div class="button-photo-delete">
                <el-button
                  v-if="formatData.mainImageSrc"
                  @click="deleteMainImage()"
                  >削除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--作成日-->
    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>履歴書の作成日を入力</h2>
          <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button
                  class="button-block"
                  :disabled="
                    $formLib.dateWithoutTime(formatData.createDate) ==
                    $formLib.dateWithoutTime($formLib.getToday())
                  "
                  @click="formatData.createDate = $formLib.getToday()"
                  >今日の日付を入力</el-button
                >
              </div>
              <div class="action-item">
                <el-button
                  class="button-block"
                  :disabled="
                    $formLib.dateWithoutTime(formatData.createDate) ==
                    $formLib.dateWithoutTime($formLib.getTommorow())
                  "
                  @click="formatData.createDate = $formLib.getTommorow()"
                  >明日の日付を入力</el-button
                >
              </div>
              <div class="action-item">
                <el-date-picker
                  v-model="formatData.createDate"
                  type="date"
                  :clearable="false"
                  placeholder="選択してください"
                  :format="'yyyy年M月d日'"
                  ref="create_date"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--確認-->
    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header" stdle="max-width: 40rem;margin: 2rem auto;">
          <h2>作成した履歴書を確認</h2>
          <p>
            修正する場合は、プレビューの修正欄をクリックまたはステップを戻ることで修正することができます
          </p>
        </div>
      </div>
    </div>

    <!--完了-->
    <div
      class="card"
      v-show="currentCardId == 'output'"
      v-if="getMode != 'production1'"
    >
      <download-item
        :formatId="formatId"
        :isSendYagiPostEnabled="isSendYagiPostEnabled"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled"
        :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled"
        :downloadActiveCollapses="downloadActiveCollapses"
      >
      </download-item>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #eff8f8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: 0.75rem;
  margin: 0.5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #eff8f8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
}

.bnr_txt h3 {
  color: #e3165c;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>

<style lang="scss" scoped>
.job-category-selector {
  position: relative;
}

.job-dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 250px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.job-dropdown-item {
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  color: #606266;

  &:hover {
    background-color: #f5f7fa;
  }
}

.edit-hobby-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.edit-hobby-list figure {
  text-align: center;
  padding: 8px;
  width: 80px;
  height: 80px;
  margin: 5px;
  border: 2px solid #fff;
}

.edit-hobby-list .seleted {
  border: 2px solid #99b8b3;
  border-radius: 5px;
  font-weight: bold;
}

.edit-hobby-list figure img {
  height: 40px;
  width: auto;
}

.edit-hobby-list figure figcaption {
  font-size: 0.6rem;
  white-space: nowrap;
  margin-top: 7px;
}

.mypr-title-block {
  text-align: center;
  margin-bottom: 20px;

  .mypr-title-catch {
    display: inline-block;
    font-weight: bold;
    font-size: 12px;
    color: #ffffff;
    background: #0f9934;
    margin-bottom: 5px;
    padding: 0 5px;
  }

  h3 {
    font-weight: bold;
    font-size: 18px;
    line-height: 1.4;
    margin-bottom: 10px;
  }

  .mypr-lead {
    text-align: left;
    line-height: 1.4;
  }

  .mypr-attention {
    color: #e3165c;
    font-size: 12px;
  }
}

.example-sentence-list {
  margin-bottom: 20px;

  .example-sentence-item {
    margin-bottom: 10px;

    .question-title {
      font-weight: bold;
      margin-bottom: 5px;

      span {
        color: #e3165c;
        font-size: 10px;
      }
    }

    .el-textarea + .question-title {
      margin-top: 8px;
    }
  }
}

.ai-mypr-modal {
  ::v-deep .v--modal {
    margin: 20px;
    width: auto !important;
    border-radius: 8px;
    padding: 20px;
    max-width: 560px;
    left: calc(50% - 270px) !important;

    @media screen and (max-width: 599px) {
      left: 0px !important;
    }
  }
}

.prime-cv-block {
  text-align: center;

  ::v-deep .el-button {
    color: #fff;
    background-color: #e3165c;
    border-color: #e3165c;
    margin: 10px 0;
  }
}
</style>

<script>
import { emitter } from '@/plugins/emitter'
import HistoryItem from './RirekishoParts/HistoryItem'
import SkillItem from './RirekishoParts/SkillItem'
import DownloadItem from './CommonParts/DownloadItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'
import HistoryItemJob from './RirekishoParts/HistoryItemJob'
import UploadPhoto from '@/components/UploadPhoto'
// import HistoryItemJob from './ShokurekishoParts/HistoryItemJob'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (cryptoObj.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
const JobHistoryData = function (columns) {
  this.companyName = columns.companyName || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.isContinuing = columns.isContinuing || false
  this.capitalStock = columns.capitalStock || ''
  this.numberOfEmployees = columns.numberOfEmployees || ''
  this.businessArea = columns.businessArea || ''
  this.projects = columns.projects || []
  this.uuid = uuidv4()
}
const ProjectHistoryData = function (columns) {
  this.projectTitle = columns.projectTitle || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.contentsOfProject = columns.contentsOfProject || ''
  this.envAndScale = columns.envAndScale || ''
  this.position = columns.position || ''
  this.uuid = uuidv4()
}
export default {
  name: 'RirekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'skill-item': SkillItem,
    'jobdetail-item': HistoryItemJob,
    'download-item': DownloadItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms,
    'upload-photo': UploadPhoto
  },
  data: function () {
    return {
      saveName: 'rirekisho',
      options: [],
      list: [],
      jobSearchQuery: '',
      showJobDropdown: false,
      filteredJobOptions: [],
      checkboxGroup1: ['Shanghai'],
      cities: ['Shanghai', 'Beijing', 'Guangzhou', 'Shenzhen'],
      loading: false,
      fullscreenLoading: false,
      aiResultView: false,
      aiResultMyprResult: '',
      states: [
        '営業・コールセンター',
        '法人営業',
        'リテール営業',
        '企画営業',
        '代理店営業',
        'アライアンス営業',
        'ルート営業',
        'インサイドセールス',
        '不動産営業',
        '金融営業',
        'IT営業',
        '医療営業',
        '半導体営業',
        '電子部品営業',
        'エレクトロニクス営業',
        '食品営業',
        '飲料営業',
        '原料営業',
        '化学製品営業',
        'セールスエンジニア',
        'コールセンター',
        'カスタマーサポート',
        'テレフォンアポインター',
        'キャリアアドバイザー',
        '人材コーディネーター',
        '事務・受付',
        '一般事務',
        '営業事務',
        '総務事務',
        '経理事務',
        '財務事務',
        '社会保険事務',
        '法務事務',
        '金融事務',
        '不動産事務',
        'アパレル事務',
        '医療事務',
        '介護事務',
        '学校事務',
        '貿易事務',
        '受付',
        '秘書',
        'データ入力',
        '経営・管理・人事',
        '経営企画',
        '事業企画',
        '人事',
        '総務',
        '法務',
        '経理',
        '財務',
        '税務',
        '内部統制',
        '内部監査',
        '広告・マーケティング',
        '広報',
        '広告プランナー',
        'コピーライター',
        '広告ディレクター',
        '広告デザイナー',
        'メディアプランナー',
        'デジタルマーケター',
        '商品企画',
        'サービス企画',
        '販売促進',
        'リサーチ',
        'データアナリスト',
        'アクセス解析',
        '販売・接客・サービス・モニター',
        'スーパー',
        'レジ打ち',
        'コンビニ',
        'アパレル販売',
        '家電量販店',
        'ガソリンスタンド',
        'レンタカー',
        '洗車',
        '住宅展示場',
        'クリーニング店',
        'ペットショップ',
        'スポーツ用品',
        '写真屋',
        '本屋',
        'インテリア',
        'ドラッグストア',
        '家事代行',
        'アンケートモニター',
        '飲食・フード',
        'ホールスタッフ',
        'キッチンスタッフ',
        '調理補助',
        '給食調理',
        '弁当調理',
        '調理師',
        'コック',
        'パティシエ',
        'バリスタ',
        'バーテンダー',
        'カフェ',
        'レストラン',
        'ラーメン屋',
        '中華料理',
        '和食',
        '寿司',
        'スイーツ',
        'パン屋',
        '居酒屋',
        'バー',
        'ダイニング',
        '食堂',
        '旅行・ホテル・ブライダル',
        '旅行カウンター',
        '旅行代理店スタッフ',
        '旅行企画',
        'ホテル',
        '旅館',
        '結婚式場スタッフ',
        'ウェディングプランナー',
        'エンタメ・レジャー・スポーツ',
        'パチンコ',
        'カラオケ',
        'イベントスタッフ',
        'ライブハウス',
        '劇場スタッフ',
        'スポーツ施設',
        'ゴルフ場スタッフ',
        'スポーツコーチ',
        'ヨガインストラクター',
        '遊園地',
        '温泉',
        '工場・製造',
        'ライン作業',
        '生産管理',
        '金属加工',
        '溶接工',
        '板金工',
        '警備・清掃・点検',
        '警備員',
        '車両誘導',
        '清掃スタッフ',
        'ハウスクリーニング',
        'ごみ収集作業員',
        'ビルメンテナンス',
        '駐車場管理',
        '軽作業・倉庫',
        'シール貼り',
        'ポスティング',
        'サンプリング',
        'ティッシュ配り',
        '試験監督',
        '看板持ち',
        '仕分け',
        '検品',
        '梱包',
        '倉庫管理',
        '在庫管理',
        'フォークリフトオペレーター',
        '建築・設計・施工・土木',
        '施工管理',
        '建築士',
        '建設作業員',
        'リフォーム',
        '外構工事',
        '重機オペレーター',
        'クレーン運転',
        '玉掛け作業員',
        '土木作業員',
        '土木設計',
        '基礎工事',
        '解体工事',
        '設備工事',
        '電気工事',
        '空調工事',
        '水道工事',
        '測量',
        '鳶職',
        '大工',
        '配管工',
        '内装工',
        '足場工',
        '防水工',
        '工事監理',
        '現場監督',
        '地質調査',
        '意匠設計',
        '内装設計',
        '構造設計',
        '構造解析',
        '耐震診断',
        '配達・運転・物流',
        '配送スタッフ',
        '宅配ドライバー',
        '新聞配達',
        'タクシー',
        '大型ドライバー',
        'バス運転手',
        '引越しスタッフ',
        '教育・保育',
        '塾講師',
        '家庭教師',
        '英会話講師',
        '日本語教師',
        '音楽講師',
        'パソコン講師',
        '教習指導員',
        '幼稚園教諭',
        '小学校教員',
        '中学校教員',
        '高校教員',
        '専門学校講師',
        '保育士',
        '保育補助',
        '学童保育',
        'ベビーシッター',
        '介護・福祉',
        '介護士',
        '介護福祉士',
        'ケアマネジャー',
        'ホームヘルパー',
        'デイサービス',
        '社会福祉士',
        '生活相談員',
        'サービス提供責任者',
        '児童指導員',
        '医療・看護',
        '医師',
        '看護師',
        '准看護師',
        '看護助手',
        '保健師',
        '産業医',
        '助産師',
        '臨床心理士',
        '歯科衛生士',
        '歯科助手',
        '整体師',
        'あん摩マッサージ指圧師',
        '鍼灸師',
        '柔道整復師',
        '調剤薬局事務',
        '薬剤師',
        '登録販売者',
        '栄養士',
        'IT・Web',
        'ITアーキテクト',
        '組み込みエンジニア',
        '制御系エンジニア',
        '社内SE',
        'フロントエンドエンジニア',
        'ネイティブアプリエンジニア',
        'IoTエンジニア',
        'インフラエンジニア',
        'QAエンジニア',
        'サポートエンジニア',
        'セキュリティエンジニア',
        'データサイエンティスト',
        'プロジェクトマネージャー',
        'プロダクトマネージャー',
        'Webプロデューサー',
        'Webデザイナー',
        'UIデザイナー',
        'UXデザイナー',
        'Webライター',
        'サイト運営',
        '技術職 （電気、化学、医薬品）',
        '電気設計',
        '回路設計',
        '半導体エンジニア',
        '画像処理エンジニア',
        'プロセスエンジニア',
        'ロボットエンジニア',
        '機械エンジニア',
        '機械設計エンジニア',
        '化学分析',
        '医薬品開発',
        'クリエイティブ・デザイン・ゲーム',
        '雑誌編集',
        '記者',
        'ライター',
        '校正',
        '製本',
        'アートディレクター',
        'グラフィックデザイナー',
        'CGデザイナー',
        'ゲームプロデューサー',
        'ゲームプランナー',
        'ゲームシナリオライター',
        'ゲームエンジニア',
        'イラストレーター',
        'アニメーター',
        'サウンドクリエイター',
        'CADオペレーター',
        'DTPオペレーター',
        '映像・芸能',
        '映像制作',
        'テレビ番組制作',
        'ラジオ番組制作',
        '撮影スタッフ',
        'フォトグラファー',
        '舞台スタッフ',
        '照明スタッフ',
        'モデル',
        '俳優',
        'エキストラ',
        'ダンサー',
        '演奏',
        '司会',
        'アナウンサー',
        '芸能マネージャー',
        '美容・理容',
        '美容師',
        '理容師',
        'ヘアメイク',
        '美容部員',
        'アイリスト',
        'エステティシャン',
        '脱毛',
        'マッサージ',
        'セラピスト',
        'アロマセラピスト',
        'ネイリスト',
        '着付け',
        'アパレル・インテリア',
        'スタイリスト',
        'ファッションデザイナー',
        'アパレルバイヤー',
        'アパレルプレス',
        'インテリアデザイナー',
        'インテリアコーディネーター',
        '店舗デザイナー',
        '戦略コンサルタント',
        '経営コンサルタント',
        'IPOコンサルタント',
        'ITコンサルタント',
        'セキュリティコンサルタント',
        '人事コンサルタント',
        'リスクコンサルタント',
        '会計コンサルタント',
        '製造業コンサルタント',
        '環境コンサルタント',
        '宅地建物取引士',
        '弁護士',
        '行政書士',
        '司法書士',
        '社会保険労務士',
        '公認会計士',
        '税理士',
        '弁理士',
        '中小企業診断士',
        '通訳',
        '翻訳',
        'ファイナンシャルプランナー',
        '証券アナリスト',
        'ファンドマネージャー',
        'アクチュアリー',
        '保険査定',
        'トレーダー',
        '融資審査',
        '債権回収',
        '不動産仕入',
        '不動産開発',
        '不動産鑑定士',
        'マンション管理',
        'アセットマネージャー',
        'プロパティマネジメント',
        '農業',
        '園芸',
        '林業',
        '漁業',
        '畜産業',
        '酪農家',
        '役所職員',
        'ナイトワーク',
        'キャバクラ',
        'クラブ',
        'パブスナック',
        'ホストクラブ',
        'フロアレディ',
        'カウンターレディ',
        'スナックレディ',
        'ナイトマネージャー'
      ],
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      saveOtherName: 'shokumukeirekisho',
      activeName: '1',
      formatData: {
        createDate: null,
        educationalHistories: [],
        jobDetailHistories: [],
        licenseHistories: [],
        commuteDescription: '',
        commuteHours: '',
        commuteMinutes: '',
        spouseNumber: '',
        hasSpouse: false,
        underDutyToSupport: false,
        job_category: '',
        reason: '',
        reasonNew: '',
        request: '',
        nowNensyu: '',
        request: '',
        nowNensyu: '',
        kibouNensyu: '',
        mainImageSrc: '',
        ai_mypr_good: '',
        ai_mypr_bad: '',
        ai_mypr_hobby: '',
        ai_mypr_wanted: '',
        ai_mypr_appeal: ''
      },
      isWeekEndFlag: true,
      activeHistoryItem: '',
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      previewScale: 1,
      previewViewerCss: {},
      isNew: false,
      textareaMinRows: 3,
      reasonLabel:
        '志望動機、特技、好きな学科、アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
      downloadActiveCollapses: ['postcard'],
      gradeYearOptions: [
        {
          value: '23',
          label: '23年卒'
        },
        {
          value: '24',
          label: '24年卒'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagishゴシック'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish明朝'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: 'ドットゴシック16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      hobbyLabel: [
        'スポーツ',
        '料理',
        '音楽鑑賞',
        '映画鑑賞',
        'スポーツ観戦',
        '裁縫',
        '旅行',
        '写真撮影',
        '絵を描く',
        '釣り',
        '資格',
        'マラソン',
        'カフェ巡り',
        'プログラミング',
        '書道',
        '温泉・サウナ',
        'ダンス',
        'キャンプ',
        'サイクリング',
        'DIY'
      ],
      hobbyImages: [
        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5MTNfMjU4NSkiPgo8cGF0aCBkPSJNMTEuNDk5IDE0QzE1LjA5MDEgMTQgMTggMTEuMDg5NyAxOCA3LjUwMDQ4QzE4IDMuOTEwMjYgMTUuMDkwMSAxIDExLjQ5OSAxQzcuOTA5OTUgMSA1IDMuOTEwMjYgNSA3LjUwMDQ4QzUgMTEuMDg5NyA3LjkwOTk1IDE0IDExLjQ5OSAxNFoiIGZpbGw9IiMwMDRENDAiLz4KPHBhdGggZD0iTTkuOTk5MzcgNTBDMTIuMjA5MyA1MCAxNCA0OC4yMDkxIDE0IDQ2LjAwMDNDMTQgNDMuNzkwOSAxMi4yMDkzIDQyIDkuOTk5MzcgNDJDNy43OTA3NCA0MiA2IDQzLjc5MDkgNiA0Ni4wMDAzQzYgNDguMjA5MSA3Ljc5MDc0IDUwIDkuOTk5MzcgNTBaIiBmaWxsPSIjMDA0RDQwIi8+CjxwYXRoIGQ9Ik00OS4yMDMxIDQzLjg0NDVMMjcuMzIwMyAxMy4yMjY5TDMwLjgyMiA4LjgyNzU0TDM3Ljg3NDEgNi40NDFDMzkuNDA3MiA2LjA3MzU5IDQwLjM4OTkgNC4zNDk2NyA0MC4wNzA3IDIuNTkwNDNDMzkuNzUxNiAwLjgzMDI4OSAzOC4yNDk5IC0wLjI5Nzk1MiAzNi43MTg0IDAuMDY5MzQ1OUwyOS45MzY3IDEuNzQzNzFDMjguNzU5IDIuMDM0MzIgMjcuNjYzMSAyLjY2MDg0IDI2Ljc1MTEgMy41NjYwOEw5Ljk1OTY1IDIwLjIzMzhMMi4yOTc0MyAyMS43OTA5QzAuNzYxMTA0IDIyLjEzMjEgLTAuMjQ1MTQ2IDIzLjgzOCAwLjA1MjAyMTggMjUuNjAzNkMwLjM0OTI4OCAyNy4zNjgyIDEuODM1MTMgMjguNTIxOCAzLjM3MjkyIDI4LjE4MTVMMTAuNTIxIDI3LjQ5NTZDMTEuOTA2MiAyNy4zNDM5IDEzLjIyMzkgMjYuNzMzNiAxNC4zMTM2IDI1LjczOTJMMTguMjk2NCAyMi4zODQxTDIyLjcxNjQgMjcuOTAxOEwxNy45NTUyIDMyLjI2NDFDMTYuMjMzNCAzMy44MzM4IDE1LjkyODQgMzcuMTQ5IDE3Ljc1MjMgMzkuMDY4MUwyOC40ODcgNDguOTEyOUMyOS43MTk4IDUwLjM0ODEgMzEuNzM0IDUwLjM2NDQgMzIuOTg0MSA0OC45NDlDMzQuMjM0MSA0Ny41MzM3IDM0LjI0ODIgNDUuMjIyMiAzMy4wMTU1IDQzLjc4NjFMMjQuNjQxIDM1LjY5NUwzMS4wMzU4IDMxLjgxMUw0NC40MzU3IDQ4LjY3NzNDNDUuNTk3NyA1MC4xODkxIDQ3LjYwNzIgNTAuMzMzNSA0OC45MjQ5IDQ4Ljk5ODdDNTAuMjQwOCA0Ny42NjM0IDUwLjM2NjcgNDUuMzU3MyA0OS4yMDMxIDQzLjg0NDVaIiBmaWxsPSIjMDA0RDQwIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzkxM18yNTg1Ij4KPHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=',
        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5MTNfMjU4OSkiPgo8cGF0aCBkPSJNMCA0Mi44NTc0QzAgNDYuODAyOCAzLjMwNTc4IDUwIDcuMzgyMjIgNTBINDIuNjE3OEM0Ni42OTY0IDUwIDUwIDQ2LjgwMjggNTAgNDIuODU3NFYxOUgwVjQyLjg1NzRaIiBmaWxsPSIjMDA0RDQwIi8+CjxwYXRoIGQ9Ik00OC45MDU0IDEzLjEyMjhDNDguOTA1NCAxMy4xMjI4IDQ4LjkxNjYgMTMuMTE0NSA0OC4zNjI2IDEyLjgzMzRDNDIuMzE2MSA5Ljc2ODc1IDM1LjIzNzcgOCAyNy42NjU4IDhIMjIuMzM2NEMxNC43NjQzIDggNy42ODYgOS43Njg3NSAxLjYzOTUzIDEyLjgzMzRDMS4wODU1OCAxMy4xMTQ1IDEuMDk2NzMgMTMuMTIyOCAxLjA5NjczIDEzLjEyMjhDMC40MTc3MDkgMTMuNDg1NCAwIDE0LjE0OTcgMCAxNC44NjdWMTZINTBWMTQuODY3QzUwIDE0LjE0OTcgNDkuNTg0NiAxMy40ODU0IDQ4LjkwNTQgMTMuMTIyOFoiIGZpbGw9IiMwMDRENDAiLz4KPHBhdGggZD0iTTI0LjUxOTQgNy4wMzQ0N0MyNi40NjEyIDcuMDM0NDcgMjguMDM2NyA1LjQ2MTIzIDI4LjAzNjcgMy41MTcyNEMyOC4wMzY3IDEuNTczMjQgMjYuNDYxMiAwIDI0LjUxOTQgMEMyMi41NzU0IDAgMjEgMS41NzMyNCAyMSAzLjUxNzI0QzIxIDUuNDYxMjMgMjIuNTc1NiA3LjAzNDQ3IDI0LjUxOTQgNy4wMzQ0N1oiIGZpbGw9IiMwMDRENDAiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zOTEzXzI1ODkiPgo8cmVjdCB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5MTNfMjU5NCkiPgo8cGF0aCBkPSJNMCAxNS42MDRMMC4wMDAzOTQ4MjEgNDYuNTkxM0MwLjAwMDM5NDgyMSA0OC40NzI4IDEuNTI2MTggNTAgMy40MTIxMSA1MEg3LjY3MjY2TDcuNjcyMjcgMTIuMTk1M0gzLjQxMTcyQzEuNTI1NzggMTIuMTk1MyAwIDEzLjcxOTYgMCAxNS42MDRaIiBmaWxsPSIjMDA0RDQwIi8+CjxwYXRoIGQ9Ik00Ni41OTI2IDEyLjE5NTNINDIuMzMyVjUwSDQ2LjU5MjZDNDguNDc1NCA1MCA1MC4wMDEzIDQ4LjQ3MjcgNTAuMDAxMyA0Ni41OTEzVjE1LjYwNEM1MC4wMDEzIDEzLjcxOTYgNDguNDc1NCAxMi4xOTUzIDQ2LjU5MjYgMTIuMTk1M1oiIGZpbGw9IiMwMDRENDAiLz4KPHBhdGggZD0iTTE3LjUyMzkgMTguNzc4M0MxNy4xODk5IDE5LjExMjMgMTcuMTg5OSAxOS42NTM5IDE3LjUyMzkgMTkuOTg3MkMxNy44NTggMjAuMzIxMyAxOC4zOTg4IDIwLjMyMTMgMTguNzMyOCAxOS45ODcyQzE5LjA2NjkgMTkuNjUzOSAxOS4wNjY5IDE5LjExMjQgMTguNzMyOCAxOC43NzgzQzE4LjM5ODggMTguNDQ1IDE3Ljg1NzkgMTguNDQ1IDE3LjUyMzkgMTguNzc4M1oiIGZpbGw9IiMwMDRENDAiLz4KPHBhdGggZD0iTTM0LjYxNzIgMi43ODM5OEMzNC42MTcyIDEuMjQ4NTMgMzMuMzY1OSAwLjAwMDk3NjU2MiAzMS44MzQyIDAuMDAwOTc2NTYySDE4LjE3MUMxNi42MzYyIDAuMDAwOTc2NTYyIDE1LjM4NzkgMS4yNDg1MyAxNS4zODc5IDIuNzgzOThWMTIuMTk1NEgxMS4wODJMMTEuMDgyIDUwLjAwMDNIMzguOTIzMVYxMi4xOTU1SDM0LjYxNzJWMi43ODM5OFpNMjcuODgzOSAyNC45MTc2TDIzLjY2MzUgMjkuMTM3OUMyMy4yMTc5IDI5LjU4MjggMjIuNDk2MyAyOS41ODI4IDIyLjA1MDYgMjkuMTM3OUwxNS41MTA3IDIyLjU5OEMxNS4yOTcyIDIyLjM4MzcgMTUuMTc2NyAyMi4wOTM1IDE1LjE3NjcgMjEuNzkxNVYxNy41NzAzQzE1LjE3NjcgMTYuOTQxIDE1LjY4NzggMTYuNDMwNiAxNi4zMTcyIDE2LjQzMDZIMjAuNTM3NUMyMC44NDAzIDE2LjQzMDYgMjEuMTMwNCAxNi41NTA0IDIxLjM0NDcgMTYuNzY0N0wyNy44ODQgMjMuMzA0NkMyOC4zMjg2IDIzLjc0OTUgMjguMzI4NiAyNC40NzE5IDI3Ljg4MzkgMjQuOTE3NlpNMzEuMjA3NyAxMi4xOTU1SDE4Ljc5NzRWMy40MTExM0gzMS4yMDc3VjEyLjE5NTVaIiBmaWxsPSIjMDA0RDQwIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzkxM18yNTk0Ij4KPHJlY3Qgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=',
        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5MTNfMjU5NSkiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI4LjQwNjIgMEg0Mi40ODg3VjUuMzM4NDhIMjguNDA2MlYwWk00My4wMjcyIDhINDEuMDU0OUgyNi45NzI1SDYuOTcyNzVDMy4xMzc2IDggMCAxMS43NjE0IDAgMTYuMzU5NFY0MS42NDA5QzAgNDYuMjM4MyAzLjEzNzYgNTAgNi45NzI3NSA1MEg0My4wMjcyQzQ2Ljg2MjQgNTAgNTAgNDYuMjM4MyA1MCA0MS42NDA5VjE2LjM1OTRDNTAgMTEuNzYxNCA0Ni44NjI0IDggNDMuMDI3MiA4Wk0xMyAxNi41QzEzIDE4Ljk4NTMgMTAuOTg1MyAyMSA4LjUgMjFDNi4wMTQ3MiAyMSA0IDE4Ljk4NTMgNCAxNi41QzQgMTQuMDE0NyA2LjAxNDcyIDEyIDguNSAxMkMxMC45ODUzIDEyIDEzIDE0LjAxNDcgMTMgMTYuNVpNMjYuNSA0MkMzMy40MDM2IDQyIDM5IDM2LjQwMzYgMzkgMjkuNUMzOSAyMi41OTY0IDMzLjQwMzYgMTcgMjYuNSAxN0MxOS41OTY0IDE3IDE0IDIyLjU5NjQgMTQgMjkuNUMxNCAzNi40MDM2IDE5LjU5NjQgNDIgMjYuNSA0MloiIGZpbGw9IiMwMDRENDAiLz4KPGNpcmNsZSBjeD0iMjYuNSIgY3k9IjI5LjUiIHI9IjguNSIgZmlsbD0iIzAwNEQ0MCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzM5MTNfMjU5NSI+CjxyZWN0IHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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',

        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5MTNfMjYwNCkiPgo8cGF0aCBkPSJNNDkuODg0IDIwLjcxNjRDNDkuNDkyMiAxOS45NDc4IDQ4LjEzMzYgMTkuNTE0MSA0Ni44NTcyIDE5Ljc1MzhMMzguNDIxMyAyMS4wODE2TDM4LjI1MDcgMTcuNTk2NUMzOC4yNjk2IDE1LjU5OSAzNS4yODA3IDEzLjY4OTEgMzMuNDQ4MiAxMi45MzE5QzMxLjc2MSAxMi4yMzE5IDI3LjY5MTYgMTEuNjgwMiAyMy4yMzAzIDEyLjM2NUwxLjg5NzMgMTUuNTMwNkMwLjU4OTI1NyAxNS43MDU2IC0wLjIzMjIxNyAxNi40ODU1IDAuMDU4NDU4MyAxNy4yNjkzQzAuMzQ5MTM0IDE4LjA1NjkgMS42NDQ1MyAxOC41NTE1IDIuOTQ2MjUgMTguMzc2NUwxOC4zMjY4IDE3LjQ5QzE3LjQ5OSAxOC4zNzY1IDE2LjY2NDkgMTkuNCAxNS44NzUgMjAuNTY4QzEyLjI0MTUgMjUuOTQ3OSAxMy4yMDIgMzEuMDYxNCAxNS4zMTI2IDMzLjE4MDdMMjMuOTM4MSA0MC44MTY3TDExLjc3MzkgNDcuMDAzMkMxMC41OTg2IDQ3LjYyNzIgMTAuNDg0OSA0OC43MDc3IDExLjUyMTIgNDkuNDE5MkMxMi41NTc1IDUwLjEzMDcgMTQuMzU4NCA1MC4xOTU0IDE1LjUzMzggNDkuNTcxNEwzMS4xMTY1IDQzLjEzQzMzLjUyNCA0MS45NTA2IDMzLjEzODYgNDAuOTE5NSAzMi42Mzk0IDM5Ljg4ODRMMzAuNDAyNCAzNi42NTQ0TDM0LjMxMzkgMzcuNzczTDM4LjYwNDUgNDcuNTgxNUMzOC45NTg0IDQ4LjUwMjMgNDAuNDgxMyA0OS4wNzY4IDQyLjAxMDUgNDguODYzN0M0My41Mzk3IDQ4LjY1MDcgNDQuNDkzOSA0Ny43MzM3IDQ0LjE0IDQ2LjgxM0w0MS43MTk4IDM1LjI0MjhDNDEuMzk3NSAzMy43NTE0IDM5Ljk2MzEgMzMuMDEzMyAzOC41NDc3IDMyLjM1NUwyNy45Njk2IDI4LjQ0QzI3LjM2MyAyNi45ODI4IDI5LjE3MDIgMjMuNzg2OCAzMi4wODk2IDIwLjkxMDRMMzIuNjAxNSAyMy41MDUzQzMyLjcyMTUgMjQuNDU2NCAzNC4yNTcgMjUuNTQwOCAzNi41MjU2IDI1LjA4MDRMNDguMjkxNiAyMi41NDI3QzQ5LjU2ODEgMjIuMzAzIDUwLjI4ODQgMjEuNDg4OCA0OS44OTAzIDIwLjcyMDJMNDkuODg0IDIwLjcxNjRaIiBmaWxsPSIjMDA0RDQwIi8+CjxwYXRoIGQ9Ik0zNC4wNzQ2IDExLjkyMzRDMzcuMzY3NCAxMS45MjM0IDQwLjAzNjcgOS4yNTQwNiA0MC4wMzY3IDUuOTYwNzRDNDAuMDM2NyAyLjY2ODQgMzcuMzY3NCAwIDM0LjA3NDYgMEMzMC43ODI3IDAgMjguMTEzMyAyLjY2ODQgMjguMTEzMyA1Ljk2MDc0QzI4LjExMzQgOS4yNTQwNiAzMC43ODI3IDExLjkyMzQgMzQuMDc0NiAxMS45MjM0WiIgZmlsbD0iIzAwNEQ0MCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzM5MTNfMjYwNCI+CjxyZWN0IHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K',

        'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM5MTNfMjYwNSkiPgo8cGF0aCBkPSJNNDYuMzIxMSA0Ni40NTA5TDI2LjYxMTMgNi43MzE4OEwyOS4wMjA3IDEuODc2MjJMMjYuNzI4OCAwTDI1IDMuNDg1MDhMMjMuMjcwNCAwTDIwLjk3ODUgMS44NzYyMkwyMy4zODg3IDYuNzMxODhMMy42NzgxMyA0Ni40NTA5SDBWNDkuNzA4Nkg1MFY0Ni40NTA5SDQ2LjMyMTFaTTEwLjUwNDEgNDYuNDUwOUMxNy44Nzg3IDQ0LjU0NDMgMjQuMjY5OCAzMC44NDM1IDI1IDIyLjcyMTRDMjUuNzI5NCAzMC44NDM1IDMyLjEyMDUgNDQuNTQ0MiAzOS40OTQzIDQ2LjQ1MDhIMTAuNTA0MVY0Ni40NTA5WiIgZmlsbD0iIzAwNEQ0MCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzM5MTNfMjYwNSI+CjxyZWN0IHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4',
        'data:image/svg+xml;base64,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',
        'data:image/svg+xml;base64,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'
      ]
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return this.$yagi.isFromMynabi === 1
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    getAIMypr: function () {
      const app = this
      app.fullscreenLoading = true
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      if (
        app.formatData.educationalHistories &&
        app.formatData.educationalHistories.length > 0
      ) {
        formData.append(
          'education',
          app.formatData.educationalHistories[
            app.formatData.educationalHistories.length - 1
          ].description
        )
      } else {
        formData.append('education', '')
      }
      formData.append('strength', this.formatData.ai_mypr_good)
      formData.append('weakness', this.formatData.ai_mypr_bad)
      formData.append('hobby', this.formatData.ai_mypr_hobby)
      formData.append('future', this.formatData.ai_mypr_wanted)
      formData.append('free', this.formatData.ai_mypr_appeal)
      formData.append('app_flag', this.$site.appFlag)
      formData.append(
        'device_flg',
        this.$deviceLib.isMobileDevice ? 'SP' : 'PC'
      )
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      this.$axios
        .post(this.$varuna.endPoints.aiIntroducePr, formData, {
          timeout: 60000
        })
        .then(function (response) {
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
          app.fullscreenLoading = false
        })
        .catch(function (error) {
          const errorMessage =
            error.response && error.response.data && error.response.data.message
          console.error(errorMessage)
          if (errorMessage === 'AIの使用回数が上限に達しました。') {
            app.aiResultView = true
          }
          if (errorMessage) {
            app.$message({
              message: errorMessage,
              type: 'error'
            })
          }
          app.fullscreenLoading = false
        })
    },
    goYagiprimeRegister: function () {
      const app = this
      const route_id = app.$route.params.id
      app.$cookies.set(
        '_YAGISH_YAGIPRIME_ROUTE_ID',
        route_id + '#self_introduction',
        null,
        null,
        'localhost'
      )
      location.href = '/yagiprime_register'
    },
    selectHobby: function (idx, val) {
      if (this.formatData.hobbies == null) {
        this.$set(this.formatData, 'hobbies', [])
      }
      if (this.formatData.hobbies == null) {
        this.formatData.hobbies = []
      }
      let isExistIndex = -1
      for (const key in this.formatData.hobbies) {
        if (this.formatData.hobbies[key].id === idx) {
          isExistIndex = key
        }
      }
      if (isExistIndex >= 0) {
        this.formatData.hobbies.splice(isExistIndex, 1)
      } else {
        if (this.formatData.hobbies.length >= 9) {
          this.$message({
            message: '趣味は最大9つまで選択可能です。',
            type: 'error'
          })
        } else {
          this.formatData.hobbies.push({ id: idx, name: val })
        }
      }
      console.error(this.formatData.hobbies)
    },
    checkedHobby: function (idx) {
      for (const key in this.formatData.hobbies) {
        if (this.formatData.hobbies[key].id === idx) {
          return 'seleted'
        }
      }
      return ''
    },
    setEducationalBackgrounds: function (historyList) {
      this.formatData.educationalHistories = []
      // 常に先頭から追加
      let index = 0
      for (const key in historyList) {
        const item = historyList[key]
        this.addEducationalHistory(index++, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    addExampleSentences: function (selectedSentences, modal) {
      const tArea = this.$refs.yourTextarea
      const startPos = tArea.selectionStart
      const endPos = tArea.selectionEnd
      const tmpStr = tArea.value
      console.error(tArea)
      console.error(startPos)
      this.formatData.reasonNew =
        tmpStr.substring(0, startPos) +
        selectedSentences +
        tmpStr.substring(endPos, tmpStr.length)
      modal.hide('reason-dialog')
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (const key in historyList) {
        const item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetEducationalBackgrounds: function () {
      this.formatData.educationalHistories = []
    },
    resetJobHistories: function () {
      this.formatData.jobDetailHistories = []
    },
    createHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new HistoryData(columns.year, columns.month, columns.description)
    },
    addHistory: function (historyList, index, refId, columns) {
      const newHistoryItem = this.createHistoryItem(columns)
      console.error(historyList)
      if (historyList == null) {
        historyList = []
      }
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    addSkills: function (index, columns) {
      if (this.formatData.skills == null) {
        this.$set(this.formatData, 'skills', [])
      }
      this.addHistory(this.formatData.skills, index, 'Skills_', columns)
    },
    moveSkills: function (params) {
      this.moveHistory(this.formatData.skills, params)
    },
    addEducationalHistory: function (index, columns) {
      if (this.formatData.educationalHistories == null) {
        this.$set(this.formatData, 'educationalHistories', [])
      }
      this.addHistory(
        this.formatData.educationalHistories,
        index,
        'EducationalHistory_',
        columns
      )
    },
    moveEducationalHistory: function (params) {
      this.moveHistory(this.formatData.educationalHistories, params)
    },
    // addJobHistory: function (index, columns) {
    //   if (this.formatData.jobHistories == null) {
    //     this.$set(this.formatData, 'jobHistories', [])
    //   }
    //   this.addHistory(this.formatData.jobHistories, index, 'JobHistory_', columns)
    // },
    addJobHistory: function (index, columns) {
      const historyList = this.formatData.jobDetailHistories
      if (this.formatData.jobDetailHistories == null) {
        console.error('ない')
        this.$set(this.formatData, 'jobDetailHistories', [])
      }
      if (!columns) columns = {}
      const newHistoryItem = new JobHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    // addJobHistory: function (index, columns) {
    //   const historyList = this.formatData.jobHistories
    //   if (!columns) columns = {}
    //   const newHistoryItem = new JobHistoryData(columns)
    //   if (typeof index === 'number') {
    //     historyList.splice(index, 0, newHistoryItem)
    //   } else {
    //     historyList.push(newHistoryItem)
    //   }
    // },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobDetailHistories, params)
    },
    addLicenseHistory: function (index, columns) {
      if (this.formatData.licenseHistories == null) {
        this.$set(this.formatData, 'licenseHistories', [])
      }
      this.addHistory(
        this.formatData.licenseHistories,
        index,
        'LicenseHistory_',
        columns
      )
    },
    addProjectHistory: function (index, columns) {
      console.error(this.formatData.jobDetailHistories)
      console.error(index)
      const targetItem = this.formatData.jobDetailHistories[index]
      if (!columns) columns = {}
      const newHistoryItem = new ProjectHistoryData(columns)
      console.error(newHistoryItem)
      targetItem.projects.push(newHistoryItem)
    },
    moveLicenseHistory: function (params) {
      this.moveHistory(this.formatData.licenseHistories, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(
          fromIndex - 1,
          2,
          historyList[fromIndex],
          historyList[fromIndex - 1]
        )
      } else if (to === 'down') {
        historyList.splice(
          fromIndex,
          2,
          historyList[fromIndex + 1],
          historyList[fromIndex]
        )
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    moveJobHistoryDetail: function (params, parentIndex) {
      this.moveHistory(
        this.formatData.jobDetailHistories[parentIndex].projects,
        params
      )
    },
    deleteSkills: function (index) {
      this.formatData.skills.splice(index, 1)
    },
    deleteEducationalHistory: function (index) {
      this.formatData.educationalHistories.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobDetailHistories.splice(index, 1)
    },
    deleteLicenseHistory: function (index) {
      this.formatData.licenseHistories.splice(index, 1)
    },
    deleteHistoryDetail: function (index, index2) {
      console.log(index, index2)
      this.formatData.jobDetailHistories[index].projects.splice(index2, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    deactivateHistoryItem: function () {
      console.error(this.formatData.hobbys)
      this.activeHistoryItem = ''
    },
    deactivateSkillsItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    },
    remoteMethod(query) {
      console.error(query)
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.options = []
        this.formatData.job_category = ''
      }
    },
    onJobSearchInput(query) {
      if (query !== '') {
        this.filteredJobOptions = this.states
          .filter((item) => {
            return item.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
          .slice(0, 20)
        this.showJobDropdown = true
      } else {
        this.filteredJobOptions = []
        this.formatData.job_category = ''
      }
    },
    onJobSearchBlur() {
      setTimeout(() => {
        this.showJobDropdown = false
      }, 200)
    },
    selectJobCategory(item) {
      this.formatData.job_category = item
      this.jobSearchQuery = item
      this.showJobDropdown = false
      this.filteredJobOptions = []
    },
    updateMainImage: function (data) {
      this.$set(this.formatData, 'mainImageSrc', data)
    },
    deleteMainImage: function () {
      this.$set(this.formatData, 'mainImageSrc', '')
    },
    handleMainImageUploadClick: function () {
      this.$yagiprimePaymentService.useFeature(this, 'main-image-upload', {
        onSuccess: () => {
          // 支払い成功時や既にPrime会員の場合はここに来るが、
          // isYagiPrimeが更新されてリアクティブにビューが切り替わるはずなので
          // ここでは特に何もしなくて良い、あるいはユーザーに通知する
        },
        onCancel: () => {}
      })
    }
  },
  watch: {
    'formatData.createDate': function (newValue, oldValue) {
      this.formatData.writeDate = this.$formLib.dateFormat(
        newValue,
        'yyyy年 m月 d日'
      )
    }
  },
  created: function () {
    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode != 'production') {
      this.isWeekEndFlag = true
    }
  },
  mounted() {
    console.error(this.formatData)
    this.list = this.states.map((item) => {
      return { value: `${item}`, label: `${item}` }
    })
    // 既存の職種データがあれば入力欄にセット
    if (this.formatData.job_category) {
      this.jobSearchQuery = this.formatData.job_category
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    if (this.formatId === 'rirekisho_job_new') {
      this.textareaMinRows = 10
      this.reasonLabel =
        '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう'
    }
    if (this.formatId === 'rirekisho_job_new_single') {
      this.textareaMinRows = 6
      this.reasonLabel =
        '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう'
    }
    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('deactivate-skill-item', this.deactivateSkillsItem)
    emitter.on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('deactivate-skill-item', this.deactivateSkillsItem)
    emitter.off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
  }
}
</script>
